import config from '../config.json';

const apiUrl =
  window.location.hostname === 'localhost' && !process.env.USE_PROD_API
    ? config.devApiUrl
    : config.apiUrl;

const apiv2Url = process.env.USE_DEV_STACK
  ? process.env.DL_SERVERLESS_DEV_HTTP_URL
  : config.apiv2Url;

const websocketUrl = process.env.USE_DEV_STACK
  ? process.env.DL_SERVERLESS_WS_URL
  : config.websocketApiUrl;

export { apiUrl, apiv2Url, websocketUrl };
